var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 112",
    width: 135,
    height: 112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 28025-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.04 90.96l87.74 46.1 42.22-67.23-60-48.81z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00aec7 } \n\t\t.s1 { fill: #048598 } \n\t\t.s2 { fill: none;stroke: #ffffff;stroke-width: 3 } \n\t\t.s3 { fill: #ffffff } \n\t\t.s4 { fill: none;stroke: #ffffff;stroke-width: 2 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13173",
    className: "s0",
    d: "m0 10c0-5.5 4.5-10 10-10h115c5.5 0 10 4.5 10 10v92c0 5.5-4.5 10-10 10h-115c-5.5 0-10-4.5-10-10z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Mask_Group_8",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13178",
    className: "s1",
    d: "m-0.4 10c0-5.5 4.4-10 10-10h115c5.5 0 10 4.5 10 10v92c0 5.5-4.5 10-10 10h-115c-5.6 0-10-4.5-10-10z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m30 21h70v70h-70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m31.5 22.5h67v67h-67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_99",
    className: "s3",
    d: "m65 66.4c-5.8 0-10.4-4.7-10.4-10.4 0-5.7 4.6-10.4 10.4-10.4 5.7 0 10.4 4.7 10.4 10.4 0 5.7-4.7 10.4-10.4 10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_100",
    className: "s3",
    d: "m57.2 40.4c-1.4 0-2.6-1.1-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.5-1.2 2.6-2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_105",
    className: "s3",
    d: "m57.2 76.8c-1.4 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_101",
    className: "s3",
    d: "m72.8 40.4c-1.5 0-2.6-1.1-2.6-2.6 0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.5-1.2 2.6-2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_103",
    className: "s3",
    d: "m72.8 76.8c-1.5 0-2.6-1.2-2.6-2.6 0-1.5 1.1-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_102",
    className: "s3",
    d: "m65 40.4c-1.4 0-2.6-1.1-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.5-1.2 2.6-2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_104",
    className: "s3",
    d: "m65 76.8c-1.4 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33812",
    className: "s4",
    d: "m41.6 75.3v-18h8.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33814",
    className: "s4",
    d: "m87.4 39.4v18h-8.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33813",
    className: "s4",
    d: "m47.5 52.8l3.3 4.7-3.3 4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33815",
    className: "s4",
    d: "m82.9 42.7l4.6-3.3 4.4 3.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreConfig);
export default __webpack_public_path__ + "static/media/pre_config.1c457b23a67f3ab8920bdb606cc4874b.svg";
export { ForwardRef as ReactComponent };